import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20.49 7.91a2.3 2.3 0 0 0-.29-.7 4.2 4.2 0 0 0-.68-.78L15.13 2a4.5 4.5 0 0 0-.77-.68 2.6 2.6 0 0 0-.71-.29 4 4 0 0 0-1-.07H7a4.7 4.7 0 0 0-2.21.27 2.3 2.3 0 0 0-1.07 1.11 4.7 4.7 0 0 0-.27 2.21v14.91a4.8 4.8 0 0 0 .27 2.21 2.4 2.4 0 0 0 1.07 1.07A4.9 4.9 0 0 0 7 23h10a4.9 4.9 0 0 0 2.21-.26 2.5 2.5 0 0 0 1.07-1.07 4.9 4.9 0 0 0 .26-2.21V8.94q.039-.518-.05-1.03M13.72 2.4q.293.23.55.5l4.39 4.4q.273.249.5.54.106.166.15.36v.13h-3.76a4.7 4.7 0 0 1-1.65-.13 1.26 1.26 0 0 1-.54-.53A4.8 4.8 0 0 1 13.23 6V2.24h.13q.191.054.36.16m5.49 18.71c-.12.23-.31.42-.54.54a4.7 4.7 0 0 1-1.65.13H7a4.8 4.8 0 0 1-1.66-.13 1.2 1.2 0 0 1-.53-.54 4.4 4.4 0 0 1-.14-1.65V4.55a4.5 4.5 0 0 1 .14-1.66c.114-.23.3-.416.53-.53A4.5 4.5 0 0 1 7 2.22h5V6a4.9 4.9 0 0 0 .26 2.21c.235.46.61.835 1.07 1.07a4.8 4.8 0 0 0 2.21.27h3.79v9.9a4.7 4.7 0 0 1-.12 1.66"
    }, null, -1)
  ]))]))
}
export default { render: render }